import React, { useMemo } from "react";
import { useLocation } from "react-router";
import { MOBILE_SLIDER_PAGES_IDS } from "./mobileSliderPagesConstants";
import { Offcanvas } from "react-bootstrap";
import SlideMobileOpenMobileAppLoadable from "./slides/SlideMobileOpenMobileApp/SlideMobileOpenMobileAppLoadable";
import SlidePwaIosInstruction from './slides/SlidePwaIosInstruction/SlidePwaIosInstruction';
import { LOCATION_COMPONENTS_SEARCH_PARAMS } from '../../../modules/Location/locationConstants';
import SlideMobilePrivacyPolicy from "./slides/SlideMobilePrivacyPolicy/SlideMobilePrivacyPolicy";
import SlideMobileClientAgreement from "./slides/SlideMobileClientAgreement/SlideMobileClientAgreement";


const MOBILE_SLIDER_PAGES_COMPONENTS = {
    [MOBILE_SLIDER_PAGES_IDS.CLIENT_AGREEMENT]: SlideMobileClientAgreement,
    [MOBILE_SLIDER_PAGES_IDS.OPEN_MOBILE_APP]: SlideMobileOpenMobileAppLoadable,
    [MOBILE_SLIDER_PAGES_IDS.PRIVACY_POLICY]: SlideMobilePrivacyPolicy,
    [MOBILE_SLIDER_PAGES_IDS.PWA_IOS_INSTRUCTION]: SlidePwaIosInstruction,
}

const mobileSliderPagesComponentsList = Object.entries(MOBILE_SLIDER_PAGES_COMPONENTS);

const MobileSliderPages = () => {
    const { search } = useLocation();

    const [openedPageId] = useMemo(() => {
        const params = new URLSearchParams(search);
        const openedPageId = params.get(LOCATION_COMPONENTS_SEARCH_PARAMS.SLIDE);
        return [openedPageId];
    }, [search]);

    return (
        <>
            {mobileSliderPagesComponentsList.map(([pageId, Component]) => (
                <Offcanvas key={pageId} show={openedPageId === pageId} placement="end" style={{ width: "100%" }}>
                    <Component/>
                </Offcanvas>

            ))}
        </>);
}

export default MobileSliderPages;
